import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "w-full"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "flex-center"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, null, -1);
const _hoisted_6 = {
  class: "flex-center"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "M", -1);
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "text-left flex flex-row items-center"
};
import { CardEnum } from "@/modules/match/enums";
import Card from "@/modules/match/components/Card.vue";
import Flag from "@/modules/vue/components/Flag.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionLogTable',
  props: {
    stats: null,
    startRank: null,
    hideDate: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("tr", null, [!!__props.startRank ? (_openBlock(), _createElementBlock("th", _hoisted_2)) : _createCommentVNode("", true), !__props.hideDate ? (_openBlock(), _createElementBlock("th", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.ClockRegular,
        size: "1rem"
      }, null, 8, ["icon"])])])) : _createCommentVNode("", true), _hoisted_5, _createElementVNode("th", null, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.Futbol,
        size: "1rem"
      }, null, 8, ["icon"])])]), _hoisted_7, _createElementVNode("th", null, [_createVNode(Card, {
        card: _unref(CardEnum).YELLOW
      }, null, 8, ["card"])]), _createElementVNode("th", null, [_createVNode(Card, {
        card: _unref(CardEnum).YELLOW_RED
      }, null, 8, ["card"])]), _createElementVNode("th", null, [_createVNode(Card, {
        card: _unref(CardEnum).RED
      }, null, 8, ["card"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stats, (log, i) => {
        return _openBlock(), _createElementBlock("tr", {
          key: log.id,
          class: "text-center even:bg-slate-50"
        }, [!!__props.startRank ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(__props.startRank + i) + ".", 1)) : _createCommentVNode("", true), !__props.hideDate ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.$date(log.season.startDate, 'YY')) + "/" + _toDisplayString(_ctx.$date(log.season.endDate, 'YY')), 1)) : _createCommentVNode("", true), _createElementVNode("td", _hoisted_10, [_renderSlot(_ctx.$slots, "label", _normalizeProps(_guardReactiveProps({
          log
        })), () => [log.competition.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: log.competition.country,
          class: "mr-2"
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(log.competition.name), 1)])]), _createElementVNode("td", null, _toDisplayString(log.goals), 1), _createElementVNode("td", null, _toDisplayString(log.matches), 1), _createElementVNode("td", null, _toDisplayString(log.yellow), 1), _createElementVNode("td", null, _toDisplayString(log.yellowRed), 1), _createElementVNode("td", null, _toDisplayString(log.red), 1)]);
      }), 128))]);
    };
  }
});